export default __webpack_public_path__ + "static/AmandaJack-d0c2802d151b0199f543bb3a8361d960.png";